<li class="slds-dropdown__item" role="presentation">
  <ng-content></ng-content>
</li>
